export enum PAGE_ROUTE {
  TSX = 'tsx',
}

export enum TSX_REQUEST_HEADER_NAME {
  TSX_URL = 'x-tsx-url',
  TSX_INVALID_URL = 'x-tsx-invalid-url',
  TRACE_PARENT = 'traceparent',
  // Sent client-to-server on every API call; validated against the CSRF_NONCE cookie server-side.
  CSRF_TOKEN = 'x-csrf-token',
  // Internal only: set by middleware and read during server-side rendering to compute CSRF_TOKEN.
  // API route validators read the CSRF_NONCE cookie instead — but /api/pageWrapperData rebuilds
  // commonData, so a client-supplied value there does affect the token it returns (resolveCsrfNonce).
  CSRF_NONCE = 'x-csrf-nonce',
}
